module.exports = __webpack_public_path__ + "static/media/istoreco-logo.88c31b26.svg";